import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

export default function InvestigationBadge({ id = 'INV-2026-042', className = '' }) {
  const navigate = useNavigate();
  const open = (e) => { e.stopPropagation(); e.preventDefault(); navigate(`/lens/investigations?id=${id}`); };
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={open}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') open(e); }}
      data-testid={`inv-badge-${id}`}
      className={`inline-flex items-center gap-0.5 text-[10px] font-mono text-apex-lens bg-teal-50 border border-teal-200 rounded px-1.5 py-0.5 cursor-pointer hover:bg-teal-100 transition-colors select-none ${className}`}
    >
      <ExternalLink className="w-2.5 h-2.5" />{id}
    </span>
  );
}
